import React from 'react'

const SvgPeople = (props: React.SVGAttributes<SVGElement>) => (
  <svg width='2em' height='2em' viewBox='0 0 29 29' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.052 7.438a2.395 2.395 0 100 4.79 2.395 2.395 0 000-4.79zM7.957 9.833a4.095 4.095 0 118.19 0 4.095 4.095 0 01-8.19 0zm9.016-3.245c0-.47.38-.85.85-.85a4.095 4.095 0 110 8.19.85.85 0 010-1.7 2.395 2.395 0 000-4.79.85.85 0 01-.85-.85zm-4.92 10.224a5.64 5.64 0 00-5.64 5.64c0 .327.265.592.592.592h10.096a.592.592 0 00.592-.592 5.64 5.64 0 00-5.64-5.64zm-5.19.45a7.34 7.34 0 0112.53 5.19 2.292 2.292 0 01-2.292 2.292H7.005a2.292 2.292 0 01-2.292-2.292 7.34 7.34 0 012.15-5.19zm12.474-1.328a.85.85 0 011.097-.492 7.34 7.34 0 014.73 6.85v.002a2.45 2.45 0 01-2.451 2.45h-.563a.85.85 0 110-1.7h.563a.75.75 0 00.75-.75 5.64 5.64 0 00-3.634-5.263.85.85 0 01-.492-1.097z'
      fill='currentColor'
    />
  </svg>
)

export default SvgPeople
